import startCase from "lodash/startCase";

const ACCESS_TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refresh_token";
const TOKEN_EXPIRES_AT_KEY = "token_expires_at";

export function storeTokenToLocalStorage(token) {
  if (token) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }
}

export function storeRefreshTokenToLocalStorage(refreshToken) {
  if (refreshToken) {
    // Tab-scoped copy too (see hydrateFromPersistentStorage below) — without
    // this, one tab's token-refresh cycle silently overwrites the refresh
    // token another already-open tab is relying on, so that tab's own next
    // refresh 401s and force-logs it out even though nothing happened there.
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
}


export function storeTokenExpiry(expiresInSeconds) {
  const expiresIn = Number(expiresInSeconds);
  if (!Number.isNaN(expiresIn) && expiresIn > 0) {
    const expiresAt = Date.now() + expiresIn * 1000;
    sessionStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(expiresAt));
    localStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(expiresAt));
  }
}

export function storeUserToLocalStorage(user) {
  localStorage.setItem("user", JSON.stringify(user));
}

export function storeAuthSession(authData) {
  if (!authData) return;

  storeTokenToLocalStorage(authData._token);
  storeRefreshTokenToLocalStorage(authData.refresh_token);
  storeTokenExpiry(authData.expires_in);
}

// Tab-scoped hydration: reads this tab's own sessionStorage copy first,
// only falling back to (and seeding from) the shared localStorage the first
// time a tab has none of its own — e.g. a freshly opened tab restoring an
// existing login. Once a tab has its own sessionStorage copy, another tab's
// later writes to localStorage (its own login or refresh cycle) can no
// longer overwrite what this tab is using.
function hydrateFromPersistentStorage(key) {
  const sessionValue = sessionStorage.getItem(key);
  if (sessionValue) return sessionValue;

  const persistedValue = localStorage.getItem(key);
  if (persistedValue) {
    sessionStorage.setItem(key, persistedValue);
    return persistedValue;
  }

  return null;
}

export function hydrateSessionTokenFromPersistentStorage() {
  return hydrateFromPersistentStorage(ACCESS_TOKEN_KEY);
}

export function getTokenFromLocalStorage() {
  return hydrateSessionTokenFromPersistentStorage();
}

export function getRefreshTokenFromLocalStorage() {
  return hydrateFromPersistentStorage(REFRESH_TOKEN_KEY);
}

export function getTokenExpiryFromLocalStorage() {
  const value = hydrateFromPersistentStorage(TOKEN_EXPIRES_AT_KEY);
  return value ? Number(value) : null;
}

export function deleteTokenFromLocalStorage() {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
}
export function convertUTCDateToLocalDate(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}

export const getLeagueNameByLeagueId = (Leagues, id) => {
  if (Leagues) {
    return Leagues.find((league) => league?.bb_id == id)?.name;
  }
};

export const getNoDataMessage = (matchTime) => {
  if (matchTime !== "all") {
    let mc = matchTime.replaceAll("_", " ");
    return ` For ${startCase(mc)}`;
  }
  return "";
};

export const formatValue = (
  value,
  { type = "number", currency = "NGN", minimumFractionDigits = 2 } = {}
) => {
  if (isNaN(value)) return "";

  return new Intl.NumberFormat("en-US", {
    style: type === "currency" ? "currency" : "decimal",
    currency: type === "currency" ? currency : undefined,
    minimumFractionDigits,
    maximumFractionDigits: minimumFractionDigits,
  }).format(value);
};

export const HandleScroll = () => {
  setTimeout(() => {
    const target = document.getElementById("pagesChilderen");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, 500);
};
